import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessingModeToggle = ({ 
  mode = 'multi-file', 
  onModeChange, 
  disabled = false,
  className = '' 
}) => {
  const modes = [
    {
      value: 'multi-file',
      label: 'Multi-File Mode',
      description: 'Process multiple separate invoice files',
      icon: 'Files',
      details: 'Each uploaded file contains one invoice. Ideal for individual invoice processing.'
    },
    {
      value: 'multi-invoice',
      label: 'Multi-Invoice Mode', 
      description: 'Process files with multiple invoices each',
      icon: 'FileStack',
      details: 'Each uploaded file may contain multiple invoices. Perfect for batch scanned documents.'
    }
  ];

  return (
    <div className={`bg-card border border-border rounded-lg p-4 ${className}`}>
      <div className="flex items-center space-x-2 mb-3">
        <Icon name="Settings" size={18} className="text-muted-foreground" />
        <h3 className="text-sm font-medium text-foreground">Processing Mode</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {modes?.map((modeOption) => (
          <button
            key={modeOption?.value}
            onClick={() => !disabled && onModeChange(modeOption?.value)}
            disabled={disabled}
            className={`
              p-4 rounded-lg border-2 text-left transition-all duration-200
              ${mode === modeOption?.value
                ? 'border-primary bg-primary/5 shadow-sm'
                : 'border-border bg-background hover:border-primary/50 hover:bg-muted/50'
              }
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            <div className="flex items-start space-x-3">
              <div className={`
                w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0
                ${mode === modeOption?.value
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
                }
              `}>
                <Icon name={modeOption?.icon} size={16} />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 mb-1">
                  <h4 className={`
                    text-sm font-medium
                    ${mode === modeOption?.value ? 'text-primary' : 'text-foreground'}
                  `}>
                    {modeOption?.label}
                  </h4>
                  {mode === modeOption?.value && (
                    <Icon name="CheckCircle" size={14} className="text-primary" />
                  )}
                </div>
                
                <p className="text-xs text-muted-foreground mb-2">
                  {modeOption?.description}
                </p>
                
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {modeOption?.details}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
      <div className="mt-3 p-3 bg-muted/50 rounded-lg">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={14} className="text-primary mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground">
            You can change the processing mode at any time before starting the upload queue. 
            This setting affects how the OCR engine processes your files.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProcessingModeToggle;